
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 121.521 121.522"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"fill":"#F26522","cx":"60.761","cy":"25.168","r":"25.168"}}),_c('circle',{attrs:{"fill":"#6E559E","cx":"96.354","cy":"60.761","r":"25.168"}}),_c('circle',{attrs:{"fill":"#F7ADCB","cx":"25.168","cy":"60.761","r":"25.168"}}),_c('circle',{attrs:{"fill":"#29ABE2","cx":"60.761","cy":"96.354","r":"25.168"}})])
          )
        }
      }
    